import { Components } from "@mui/material";

const MuiContainer: Components["MuiContainer"] = {
  defaultProps: {
    maxWidth: "xl",
  },
};

export { MuiContainer };
